export * from './admin-contracts-api-client.service';
import { AdminContractsApiClient } from './admin-contracts-api-client.service';
export * from './admin-contracts-api-client.serviceInterface';
export * from './admin-registration-protocols-api-client.service';
import { AdminRegistrationProtocolsApiClient } from './admin-registration-protocols-api-client.service';
export * from './admin-registration-protocols-api-client.serviceInterface';
export * from './admin-tenants-api-client.service';
import { AdminTenantsApiClient } from './admin-tenants-api-client.service';
export * from './admin-tenants-api-client.serviceInterface';
export const APIS = [AdminContractsApiClient, AdminRegistrationProtocolsApiClient, AdminTenantsApiClient];
